export default {"src":"/_next/static/media/ico_check3.63e82f95.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};